<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Edit Promo Mobile</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <h6 class="form-title">DATA PROMO</h6>
                    <b-row>
                        <b-col md="5">
                            <b-form-group label="Nama Promo">
                                <b-form-input v-model="input.title" name="namaPromo" required></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="5">
                            <b-form-group label="Link Url Promo"
                            description="contoh : https://gadai.pugindo.com/">
                                <b-form-input v-model="input.link" name="linkPromo" required></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                  
                    <label for="">Periode Promo</label>
                    <b-row>
                        <b-col md="4">
                            <date-range-picker
                                class="w-100"
                                ref="picker"
                                :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                                v-model="dateRange"
                                >
                            </date-range-picker>
                        </b-col>
                    </b-row>

                    
                </div>
                <div class="form-content-wrapper">
                    <div>
                        <!-- <b-button variant="pgiBtn" class="mb-2" @click="addFotoPendukung" name="fotoPendukungAddBtn"><i
                        class="fa fa-plus mr-2"></i>Foto Pendukung</b-button> -->
                        <div class="text-danger mt-2 mb-2" v-show="fotoPendukungError">* Foto Pendukung Maksimal 20 Foto
                        </div>
                        <FotoPendukung v-for="item in fotoPendukung" v-bind:key="item.index" :fotoPendukung="item"
                            :length="fotoPendukung.length" :minLength="minLengthFotoPendukung"
                            @remove="removeFotoPendukung" @showModalCam="openModalCam"
                            @showModalPreview="openModalPreview" :lat="lat" :long="long" :fotoPromo="true" isRemove />
                    </div>
                </div>

                <b-row no-gutters>
                    <b-col cols="7" sm="3" xl="2">
                        Token
                    </b-col>
                    <b-col cols="1">
                        <b-form-checkbox id="token" v-model="input.tokenHeader" name="token" value="true" unchecked-value="false">
                        </b-form-checkbox>
                    </b-col>
                </b-row>
                <div class="smallText text-muted">
                    Checklist apabila Promo membutuhkan Data Pengguna
                </div>
                <b-row no-gutters class="pt-3">
                    <b-col cols="7" sm="3" xl="2">
                       Is Active
                    </b-col>
                    <b-col cols="1">
                        <b-form-checkbox id="isActive" v-model="input.isActive" name="isActive" value="true" unchecked-value="false">
                        </b-form-checkbox>
                    </b-col>
                </b-row>
                <div class="smallText text-muted">
                    Checklist untuk mengaktifkan Promo
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="promoSubmitBtn" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalWebCam idWebcam="webcam-input-elek" @photoTaken="setResult" />
        <ModalPreview modalId="modal-preview-gadai" :fotoPreview="activeFotoPreview" />
        <ModalConfirm id="modal-confirm-input" title="Confirm Edit Promo Mobile" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah promo mobile ini?" @submit="onSubmit" />
    </div>
</template>
<script>
import FotoPendukung from '../../../components/webcam/FotoPendukung'
import ModalWebCam from '../../../components/webcam/ModalWebCam'
import ModalPreview from '../../../components/webcam/ModalPreview'
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    name: 'input-promo-mobile',
    components: {
        FotoPendukung,
        ModalWebCam,
        ModalPreview,
        DateRangePicker
    },
    data(){
        return{
            id: null,
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            input: {
                namaPromo: "",
                link: null,
                tokenHeader: false,
                isActive: true
            },
            dateRange: {startDate:null , endDate:null},

            fotoPendukung: [
                    {
                        index: 0,
                        id: 0,
                        checkFotoBarangPendukung: false,
                        fotoBarangPendukungPlaceholder: 'Choose a file',
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: null,
                    }
                ],
            fotoPendukungError: false,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            minLengthFotoPendukung: 1,
            activeFotoPreview: "",

            lat:0,
            long:0,

            fields: [
                { key: "checkCabang", label: "Cabang", tdClass: "checkboxCabang" },
            ],

            promo : null,

            filterCabang: null,
			filterOn: ["name"],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            checkAllCabang: false,
            disabled: false,
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            
            cabangItems: [],
            optionTipePinjaman: [],
            optionJenisBarang: [],
            optionMerkBarang: [],
            optionTipeBarang: [],

            dateError: false,
        }
    },
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init() {

            this.initStatus = 1
    
        },

        validateDate() {
            const startDate = new Date(this.input.startDate);
            const endDate = new Date(this.input.endDate);
            if (startDate > endDate) {
                this.dateError = true;
            } else {
                this.dateError = false;
            }
        },

         //----------------- Fungsi Tambah Hapus Data Foto Pendukung -----------------

        //  addFotoPendukung() {
        //     if (this.fotoPendukung.length < 20) {
        //         this.fotoPendukung.unshift({
        //             id: 0,
        //             index: this.indexFotoPendukung,
        //             checkFotoBarangPendukung: false,
        //             fotoBarangPendukungPlaceholder: 'Choose a file',
        //             fotoBarangPendukung: null,
        //             fotoBarangPendukungBase64: null,
        //             activeFotoPendukungBase64: null
        //         })
        //         this.indexFotoPendukung++;
        //     } else {
        //         this.fotoPendukungError = true;
        //     }
        // },

        removeFotoPendukung(index) {
            this.fotoPendukung = this.fotoPendukung.filter(item => item.index != index)
            this.fotoPendukungError = false;
        },

        openModalCam(index) {
            this.activeFotoPendukungIndex = index
            this.$bvModal.show("webcam-input-elek")
        },

        openModalPreview(index) {
            this.activeFotoPreviewIndex = index
            let idx = this.fotoPendukung.findIndex(item => item.index == this.activeFotoPreviewIndex);
            this.activeFotoPreview = this.fotoPendukung[idx].activeFotoPendukungBase64
            this.$bvModal.show("modal-preview-gadai")
        },

        //----------------- Fungsi Pagination, Sorting, dan Filtering -----------------

        onPageChange(){
            let limit = null
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
        },

        onLimitChange(){
            if(this.input.show == 'All'){
                this.perPage = this.rows
            }else{
                this.perPage = this.input.show
                this.onPageChange()
            }
            
        },
        
        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit(){

            let payload = new FormData()
        
            // //----------------- Append Data Promo -----------------

            payload.append("title", this.input.title)

            if(this.fotoPendukung[0].activeFotoPendukungBase64.includes('data:image/')){
                payload.append("image", this.fotoPendukung[0].fotoBarangPendukung)
            }

            payload.append("link", this.input.link)
            payload.append("tokenHeader", this.input.tokenHeader)
            payload.append("isActive", this.input.isActive)
            payload.append("startDate", this.$helper.formatTimestamp(this.dateRange.startDate))
            payload.append("endDate", this.$helper.formatTimestamp(this.dateRange.endDate))
            
            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("promo-mobile/", payload).then(() => {
                this.$helper.setFlash("Promo Mobile telah berhasil ubah!")
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
            
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        async setResult(result) {
            //letakin ke null masing2
           
            let formattedDate = this.$helper.formatTanggalDMY()
            let waktu = this.$helper.waktu24()
        
            //resize image
           var newResult = await this.$helper.resizeImage(result)

           //add timestamp & location
           let img = new Image()
           img.src = newResult
           img.onload = () => {
               let canvas = document.createElement('canvas')
               let ctx = canvas.getContext('2d')
               canvas.setAttribute("width", img.width);
               canvas.setAttribute("height", img.height);
               ctx.drawImage(img, 0, 0,)
               ctx.font = "14pt Arial";
               ctx.fillStyle = "#ffffff"; //<======= here
               ctx.fillText(formattedDate + ' ' + waktu, 10, img.height - 40 ,);
               ctx.strokeText(formattedDate + ' ' + waktu, 10, img.height - 40 ,);
               ctx.fillText(this.lat + ' ' +this.long, 10, img.height - 10 ,);
               ctx.strokeText(this.lat + ' ' +this.long, 10, img.height - 10 ,);
               let newBase64Str = canvas.toDataURL('image/jpeg', 0.9)

               let idx = this.fotoPendukung.findIndex(item => item.index == this.activeFotoPendukungIndex);
                this.fotoPendukung[idx].fotoBarangPendukungBase64 = newBase64Str
                this.fotoPendukung[idx].activeFotoPendukungBase64 = newBase64Str
                this.fotoPendukung[idx].fotoBarangPendukungPlaceholder = "Foto dari Kamera"
                this.fotoPendukung[idx].checkFotoBarangPendukung = true
           }
        },

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        toggleAll(checked) {
            for(let i=0; i< this.cabangItems.length; i++){
                this.cabangItems[i].selected = checked
            }
        },

        updateTotalItem(){
            this.rows = this.cabangItems.length
            if (this.perPage > this.rows) this.perPage = this.rows
        },


        openModalConfirm(){
        
            if (this.input.title == null || this.input.title == "") {
                this.$helper.toastErr(this, "Mohon masukan Judul!")
            }
            else if (this.input.link == null || this.input.link == "") {
                this.$helper.toastErr(this,  "Mohon masukan Link!")
            }
            else if (this.dateRange.startDate == null) {
                this.$helper.toastErr(this, "Mohon isi Periode Promo!")
            }
            else if (this.fotoPendukung[0].fotoBarangPendukung == null) {
                this.$helper.toastErr(this, "Mohon upload Banner Promo!")
            }
            else if (this.$helper.removeThousandSeparator(this.input.hargaBarangMinimal) > this.$helper.removeThousandSeparator(this.input.hargaBarangMaksimal)) {
                this.$helper.toastErr(this, "Minimal harga barang tidak boleh melebihi maksimal harga barang")
            }
            else {
                this.$bvModal.show("modal-confirm-input")
            }
        },

        roundPersen(){
            var x = Number(this.input.nominalPersen).toFixed(2);
            this.input.nominalPersen = x;
        }
    },

    watch: {
        'input.link': function(newVal) {
            this.input.link =  newVal.replace(/\s+/g, '');
        },
    },
    created(){
        this.init()
    }
}
</script>
